import { Icon, SemanticCOLORS, SemanticICONS } from "semantic-ui-react";
import styled from "@emotion/styled";
import { SpeakingSessionExaminerAvailabilityDto } from "api/planning";
import { ExaminerAvailabilityDisplay } from "./ExaminerAvailabilityDisplay";

export type Props = {
  header: string;
  description: string;
  icon: SemanticICONS;
  color: SemanticCOLORS;
  availabilities?: SpeakingSessionExaminerAvailabilityDto[];
  unavailabilities?: SpeakingSessionExaminerAvailabilityDto[];
}

export const ManageExaminerToRoomStructurePopup = ({ header, description, icon, color, availabilities, unavailabilities }: Props) => {

  return <div>
    <div>
      <S.Header>
        <Icon name={icon} color={color} /> {header}
      </S.Header>
      <S.HeaderDescription>
        {description}
      </S.HeaderDescription>
    </div>
    <ExaminerAvailabilityDisplay availabilities={availabilities} unavailabilities={unavailabilities} />
  </div>
};


const S = {
  Header: styled.div`
        font-weight: bold;
        margin-bottom: 0.5em;
  `,
  HeaderDescription: styled.div`
        font-size: 0.9em;
        color: #666;
    `,
};